import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Site } from './models/Site';

@Injectable({
  providedIn: 'root'
})
export class SiteService {
  private readonly http = inject(HttpClient);

  getSites(dealerId: string): Observable<Site[]> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris.getSites}`;
    return this.http
      .get<{
        data: Site[];
      }>(url, { headers: { dealerId } })
      .pipe(map((response) => response.data));
  }
}
